import React, { useEffect, useState } from "react";
import { SendPostRequest } from "../../http";
import { useSelector } from "react-redux";
import Spinner from "../Spinner";
import { Link } from "react-router-dom";
import OwlCarousel from "react-owl-carousel";
import { limitParagraphByCharLimit } from "../../Helper/Helper";

function ThirdFeaturedServices({ setIsdata }) {
  const [featuredService, setFeaturedService] = useState([]);
  const [loading, setLoading] = useState(true);
  const sitedata = useSelector((store) => store.global.loginData);

  useEffect(() => {
    getFeaturedService();
  }, []);

  const getFeaturedService = async () => {
    setLoading(true);
    const response = await SendPostRequest("services/featured_services");
    if (response?.data.length < 5 && sitedata?.site_type === "hospitals") {
      setIsdata(true);
    }
    setFeaturedService(response?.data);
    setLoading(false);
  };

  const options = {
    loop: true,
    nav: true,
    dots: false,
    autoplay: true,
    autoplayTimeout: 2500,
    autoplayHoverPause: true,
    smartSpeed: 1000,
    margin: 30,
    // animateIn: "slideInRight",
    // animateOut: "slideOutLeft",
    responsive: {
      0: { items: 1 },
      600: { items: 2 },
      1000: { items: 3 },
    },
  };

  return (
    <>
      {loading ? (
        <div className="d-flex justify-content-center">
          <Spinner />
        </div>
      ) : (
        featuredService?.length > 0 && (
          <section
            id="feature-section" className="feature-section pt-5 pb-0"
          >
            <div className="container">
              <div className="row">
                <div className="offset-md-2 col-md-8">
                  <div className="title-wrap text-center">
                    <div className="section-title margin-bottom-60">
                      <h2 className="section-title mb-0 text-uppercase">
                        {sitedata?.site_type === "hospitals" ? "Our Specialties" : "Services"}
                      </h2>
                      <span className="section-border-bottom center"></span>
                    </div>
                  </div>
                </div>
                </div>
                <div className="row" data-animation="fadeInDown">
                  <OwlCarousel className="service-main-wrapper" {...options}>
                    {featuredService?.map((service, index) => (
                      <div key={index} className="item">
                        <div className="service-box-wrap service-box-style-2 mb-4">
                          <div className="service-box-inner">
                            <div className="service-thumb">
                              <Link
                                to={`/${sitedata?.site_type === "hospitals" ? "speciality" : "service"}/${service?.uid}/${service?.service_title
                                  .replaceAll(" ", "-")
                                  .replaceAll("/", "-")}`}
                              >
                                <img
                                  className="img-fluid squared w-100"
                                  src={
                                    service?.service_image_url ||
                                    "/assets/images/default.jpg"
                                  }
                                  style={{ height: "auto" }}
                                  width="100%"
                                  alt={service?.service_title}
                                />
                              </Link>
                            </div>
                            <div className="service-main-content">
                              <h3 className="mb-0 service-title">
                                <Link
                                  to={`/${sitedata?.site_type === "hospitals" ? "speciality" : "service"}/${service?.uid}/${service?.service_title
                                    .replaceAll(" ", "-")
                                    .replaceAll("/", "-")}`}
                                >
                                  {service?.service_title}
                                </Link>
                              </h3>
                              <div className="service-link">
                                <Link
                                  to={`/${sitedata?.site_type === "hospitals" ? "speciality" : "service"}/${service?.uid}/${service?.service_title
                                    .replaceAll(" ", "-")
                                    .replaceAll("/", "-")}`}
                                  className="link"
                                >
                                  <i className="ti-arrow-top-right"></i>
                                </Link>
                              </div>
                            </div>
                            <div className="service-overlay-content">
                              <div className="service-meta">
                                <h3 className="mb-2 service-title">
                                  <Link
                                    to={`/${sitedata?.site_type === "hospitals" ? "speciality" : "service"}/${service?.uid}/${service?.service_title
                                      .replaceAll(" ", "-")
                                      .replaceAll("/", "-")}`}
                                  >
                                    {service?.service_title}
                                  </Link>
                                </h3>
                                <div className="service-link">
                                  <Link
                                    to={`/${sitedata?.site_type === "hospitals" ? "speciality" : "service"}/${service?.uid}/${service?.service_title
                                      .replaceAll(" ", "-")
                                      .replaceAll("/", "-")}`}
                                    className="link"
                                  >
                                    <i className="ti-arrow-top-right"></i>
                                  </Link>
                                </div>
                              </div>
                              {/* <div className="service-desc">
                                <p
                                  className="mb-0"
                                  dangerouslySetInnerHTML={{
                                    __html:
                                      limitParagraphByCharLimit(service?.clean_service_description, 80) +
                                      (service?.clean_service_description?.length > 80 ? "..." : ""),
                                  }}
                                />
                              </div> */}
                            </div>
                          </div>
                        </div>
                      </div>
                      // <div className="item animated fadeInRight visible" key={index}>
                      //   <div className="service-box-wrap service-box-style-2 mb-5">
                      //     <div className="service-box-inner">
                      //       <div className="service-thumb">
                      //         <img
                      //           className="img-fluid squared w-100 third-fservices-image"
                      //           src={service?.service_image_url}
                      //           alt={service?.title}
                      //         />
                      //       </div>
                      //       <div className="service-main-content">
                      //         <h3 className="mb-0 service-title">
                      //           {service?.service_title}
                      //         </h3>
                      //         <div className="service-link">
                      //           <Link
                      //                 to={`/${sitedata?.site_type === "hospitals" ? "speciality" : "service"}/${service?.uid}/${service?.service_title
                      //                 .replaceAll(" ", "-")
                      //                 .replaceAll("/", "-")}`}
                      //             rel="noopener noreferrer"
                      //             className="link"
                      //           >
                      //             <i className="ti-arrow-top-right"></i>
                      //           </Link>
                      //         </div>
                      //       </div>
                      //       <div className="service-overlay-content">
                      //         <div className="service-meta">
                      //           <h3 className="mb-2 service-title">
                      //             <a href={service?.link} className="text-black">
                      //               {service?.service_title}
                      //             </a>
                      //           </h3>
                      //           <div className="service-link">
                      //             <Link
                      //               to={`/${sitedata?.site_type === "hospitals" ? "speciality" : "service"}/${service?.uid}/${service?.service_title
                      //                   .replaceAll(" ", "-")
                      //                   .replaceAll("/", "-")}`}
                      //               rel="noopener noreferrer"
                      //               className="link"
                      //             >
                      //               <i className="ti-arrow-top-right"></i>
                      //             </Link>
                      //           </div>
                      //         </div>
                      //         <div
                      //           className="service-desc mb-4"
                      //           dangerouslySetInnerHTML={{
                      //             __html:
                      //               limitParagraphByCharLimit(service?.clean_service_description, 80) +
                      //               (service?.clean_service_description?.length > 80 ? "..." : ""),
                      //           }}

                      //         />
                      //         {/* <div
                      //           className="service-desc mb-4"
                      //           dangerouslySetInnerHTML={{
                      //             __html: service.service_description.slice(
                      //               0,
                      //               80
                      //             ),
                      //           }}
                      //         /> */}
                      //       </div>
                      //     </div>
                      //   </div>
                      // </div>
                    ))}
                  </OwlCarousel>
                </div>
              </div>
          </section>
        )
      )}
    </>
  );
}

export default ThirdFeaturedServices;
